import React from "react"
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image"
import Edges from "../../Edges"

interface IApp {
  app: {
    featuredImage: {
      node: {
        altText: string
        gatsbyImage: ImageDataLike
      }
    }
    title: string
    compatibleAppsUrl: { url: string }
  }
}
interface ICompatibleAppsProps {
  heading: string
  description: string
  apps: IApp[]
}

const CompatibleApps: React.FC<ICompatibleAppsProps> = ({
  heading,
  description,
  apps,
}) => {
  return (
    <div
      id="compatible-apps"
      className="mb-[70px] overflow-hidden bg-lightGrey px-8 pt-14 pb-4 text-center"
    >
      <Edges size="md">
        <div className="mx-auto">
          <h2 className="mb-[17px] uppercase text-darkBlue">{heading}</h2>
          <p className="mx-auto mb-10 max-w-[810px] text-center text-body1">
            {description}
          </p>
          <div className="mx-auto flex max-w-[700px] flex-wrap justify-evenly sm:justify-start">
            {apps?.map?.(({ app }, index) => {
              const gatsbyImage =
                app?.featuredImage?.node?.gatsbyImage &&
                getImage(app?.featuredImage?.node?.gatsbyImage)

              return (
                <div
                  className="mb-11 mr-4 inline-block"
                  key={app?.title || index}
                >
                  {gatsbyImage && (
                    <div className="overflow-hidden rounded-2xl">
                      <GatsbyImage
                        image={gatsbyImage}
                        alt={app?.featuredImage?.node?.altText || ""}
                      />
                    </div>
                  )}

                  <a
                    rel="noopener noreferrer"
                    className=" inline-block cursor-pointer px-[3%] text-center text-body2"
                    href={app?.compatibleAppsUrl?.url || "#"}
                    target="_blank"
                  >
                    {app?.title || ""}
                  </a>
                </div>
              )
            })}
          </div>
        </div>
      </Edges>
    </div>
  )
}

export default CompatibleApps
